import { NgModule } from '@angular/core';
import {ItemSummaryDispatcherComponent} from './item-summary-dispatcher/item-summary-dispatcher.component';
import {ItemSummaryPPSDispatcherComponent} from './item-summary-pps-dispatcher/item-summary-pps-dispatcher.component';
import {AssetSummaryComponent} from './asset-summary/asset-summary.component';
import {AssetPPSSummaryComponent} from './asset-pps-summary/asset-pps-summary.component';
import {EquipmentSummaryComponent} from './equipment-summary/equipment-summary.component';
import {EquipmentPPSSummaryComponent} from './equipment-pps-summary/equipment-pps-summary.component';
import {CommonModule} from '@angular/common';
import {ItemSummaryCommonComponent} from './item-summary-common/item-summary-common.component';
import {AssetLienComponent} from './item-summary-common/asset-lien/asset-lien.component';
import {AssetInfoComponent} from './item-summary-common/asset-info/asset-info.component';
import {AssetMoveReasonComponent} from './item-summary-common/move-assets/asset-move-reason/asset-move-reason.component';
import {AssetMoveDestinationComponent} from './item-summary-common/move-assets/asset-move-destination/asset-move-destination.component';
import {AssetMoveSaleInfoComponent} from './item-summary-common/move-assets/asset-move-sale-info/asset-move-sale-info.component';
import {AngularMaterialModule, UiComponentModule} from '@rbaip/ui-component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {AssetActionPopupComponent} from './item-summary-common/asset-action-popup/asset-action-popup.component';
import {AssetLienCardComponent} from './item-summary-common/asset-lien/asset-lien-card/asset-lien-card.component';
import {OpportunityContractCardComponent} from './item-summary-common/opportunity-contract-card/opportunity-contract-card.component';
import {AssetServicesComponent} from './item-summary-common/asset-services/asset-services.component';
import {AssetControlGroupBudgetsComponent} from './asset-package/asset-control-group-budgets/asset-control-group-budgets.component';
import {AssetSaleInfoComponent} from './item-summary-common/asset-sale-info/asset-sale-info.component';
import {AssetRbDetailsComponent} from './item-summary-common/asset-rb-details/asset-rb-details.component';
import {AssetSellingDetailsComponent} from './item-summary-common/asset-selling-details/asset-selling-details.component';
import {AssetSummaryPhotoComponent} from './item-summary-common/asset-summary-photo/asset-summary-photo.component';
import {ItemSummaryEquipmentCoreModule} from './equipment-core/item-summary-equipment-core.module';
import {MoveReasonCustomerConfirmationComponent} from './item-summary-common/move-assets/move-reason-customer-confirmation/move-reason-customer-confirmation.component';
import {LookupContractComponent} from './item-summary-common/lookup-contract/lookup-contract.component';
import {AddressFormModule} from '@rbaip/address-form';
import {appConfig} from './shared/app.config';
import { MatIconRegistry } from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {AssetLienEditComponent} from './item-summary-common/asset-lien/asset-lien-edit/asset-lien-edit.component';
import {ResellCollapsedAssetComponent} from './item-summary-common/resell-collapsed-asset/resell-collapsed-asset.component';
import {ConsignorContactComponent} from './item-summary-common/consignor-contact/consignor-contact.component';
import {ContactCardComponent} from './contact/contact-card/contact-card.component';
import {AssetAuditComponent} from './item-summary-common/asset-audit/asset-audit.component';
import {DataTableModule} from 'mars-modules';
import { ItemBadgesComponent } from './item-summary-common/item-badges/item-badges.component';
import {ItemSoldInfoComponent} from './item-summary-common/item-sold-info/item-sold-info.component';
import {ItemLienInfoComponent} from './item-summary-common/item-lien-info/item-lien-info.component';
import {ItemIssuesComponent} from './item-summary-common/item-issues/item-issues.component';
import {ItemComponentizationComponent} from './item-summary-common/item-componentization/item-componentization.component';
import {ItemCommonNotesComponent} from './item-summary-common/item-common-notes/item-common-notes.component';
import {ItemCommonNotesModule} from '@rbaip/item-common-notes';
import {MoveItemButtonComponent} from './item-summary-common/move-assets/move-item-button/move-item-button.component';
import {MoveAssetsComponent} from './item-summary-common/move-assets/move-assets.component';
import {ReconsignAssetComponent} from './item-summary-common/reconsign-asset/reconsign-asset.component';
import {MergePackageComponent} from './asset-package/merge-package/merge-package.component';
import {ItemSaleInfoSectionComponent} from './item-summary-common/item-sale-info-section/item-sale-info-section.component';
import {ContactSellerLinkComponent} from './item-summary-common/contact-seller-link/contact-seller-link.component';
import {ContractCardComponent} from './item-summary-common/contract-card/contract-card.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {LookupContractOpportunityAdvancedComponent} from './item-summary-common/lookup-contract-opportunity-advanced/lookup-contract-opportunity-advanced.component';
import {ContactEditComponent} from './contact/contact-edit/contact-edit.component';
import {CreateAddendumComponent} from './item-summary-common/move-assets/create-addendum/create-addendum.component';
import {MarkAssetAsReviewedComponent} from './item-summary-common/mark-asset-as-reviewed/mark-asset-as-reviewed.component';
import {ResellAbandonedAssetComponent} from './item-summary-common/resell-abandoned-asset/resell-abandoned-asset.component';
import {DataTableV2Module} from '@rbaip/data-table-v2';
import {StorageLocationComponent} from "./item-summary-common/storage-location-details/storage-location.component";
import {BackToPricingComponent} from './item-summary-common/back-to-pricing/back-to-pricing.component';
import { AssetTypeChangeDialogComponent } from './item-summary-common/asset-type-change-dialog/asset-type-change-dialog.component';
import { ItemErrorMessageComponent } from './item-summary-common/item-error-message/item-error-message.component';
import {MarsCurrencyPipe} from './shared/currencyUtil';
export const DATE_FORMATS = {
  display: {
    dateInput: appConfig.dateFormat.toUpperCase(),
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  },
};

@NgModule({
    imports: [
        AngularMaterialModule,
        CommonModule,
        UiComponentModule,
        FlexLayoutModule,
        FormsModule,
        ScrollingModule,
        ReactiveFormsModule,
        ItemSummaryEquipmentCoreModule,
        AddressFormModule,
        DataTableModule,
        ItemCommonNotesModule,
        DataTableV2Module
    ],
  declarations: [
    ItemSummaryDispatcherComponent,
    ItemSummaryPPSDispatcherComponent,
    AssetSummaryComponent,
    AssetPPSSummaryComponent,
    EquipmentSummaryComponent,
    EquipmentPPSSummaryComponent,
    ItemSummaryCommonComponent,
    AssetLienComponent,
    AssetInfoComponent,
    AssetMoveReasonComponent,
    AssetMoveDestinationComponent,
    AssetMoveSaleInfoComponent,
    CreateAddendumComponent,
    AssetActionPopupComponent,
    AssetLienCardComponent,
    OpportunityContractCardComponent,
    AssetServicesComponent,
    AssetControlGroupBudgetsComponent,
    AssetSaleInfoComponent,
    AssetRbDetailsComponent,
    AssetSellingDetailsComponent,
    AssetSummaryPhotoComponent,
    MoveReasonCustomerConfirmationComponent,
    LookupContractComponent,
    AssetLienEditComponent,
    ResellCollapsedAssetComponent,
    ConsignorContactComponent,
    ContactCardComponent,
    AssetAuditComponent,
    ItemBadgesComponent,
    ItemSoldInfoComponent,
    AssetLienComponent,
    ItemLienInfoComponent,
    ItemIssuesComponent,
    ItemComponentizationComponent,
    ItemCommonNotesComponent,
    MoveItemButtonComponent,
    MoveAssetsComponent,
    ReconsignAssetComponent,
    MergePackageComponent,
    ItemSaleInfoSectionComponent,
    ContactSellerLinkComponent,
    ContractCardComponent,
    LookupContractOpportunityAdvancedComponent,
    ContactEditComponent,
    MarkAssetAsReviewedComponent,
    ResellAbandonedAssetComponent,
    StorageLocationComponent,
    BackToPricingComponent,
    AssetTypeChangeDialogComponent,
    ItemErrorMessageComponent,
    MarsCurrencyPipe
  ],
  entryComponents: [
    ConsignorContactComponent,
    AssetAuditComponent,
    AssetLienComponent,
    AssetLienEditComponent,
    MoveAssetsComponent,
    ReconsignAssetComponent,
    ResellCollapsedAssetComponent,
    MergePackageComponent,
    AssetControlGroupBudgetsComponent,
    LookupContractOpportunityAdvancedComponent,
    ContactEditComponent
  ],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS}
  ],
  exports: [
    ItemSummaryDispatcherComponent,
    ItemSummaryPPSDispatcherComponent,
    MoveAssetsComponent,
    AssetMoveDestinationComponent,
    AssetMoveReasonComponent,
    AssetMoveSaleInfoComponent,
    MoveReasonCustomerConfirmationComponent,
    AssetInfoComponent,
    AssetSaleInfoComponent,
    OpportunityContractCardComponent,
    ReconsignAssetComponent,
    ResellAbandonedAssetComponent,
    ResellCollapsedAssetComponent,
    ItemIssuesComponent,
    StorageLocationComponent,
    MarsCurrencyPipe
  ]
})
export class ItemSummaryModule {
  constructor(private matIconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer) {
    this.registerIcons();
  }

  private registerIcons(): void {
    const cdnBaseHref = appConfig.cdnBaseHref;
    this.matIconRegistry
      .addSvgIcon('back-to-wip',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/back-to-wip.svg'))
      .addSvgIcon('inventory',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/inventory.svg'))
      .addSvgIcon('other-contract',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/other-contract.svg'))
      .addSvgIcon('other-opportunity',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/other-opportunity.svg'))
      .addSvgIcon('event-channel',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/event-channel.svg'))
      .addSvgIcon('icon-contract-ready',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Contract-Ready.svg'))
      .addSvgIcon('icon-info-complete',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Information-Complete.svg'))
      .addSvgIcon('icon-missing-info',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Information-Missing.svg'))
      .addSvgIcon('icon-yom-checked',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/YOM-Checked.svg'))
      .addSvgIcon('undercarriage-icon',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/undercarriage-icon.svg'))
      .addSvgIcon('icon-has-lien',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Lien.svg'))
      .addSvgIcon('icon-pricing',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Icon-Priced.svg'))
      .addSvgIcon('icon-checked-in',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Icon-CheckedIn.svg'))
      .addSvgIcon('icon-checked-out',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Icon-CheckedOut.svg'))
      .addSvgIcon('icon-not-in-yard',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Icon-NotInYard.svg'))
      .addSvgIcon('live-rbauction-icon',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/live-rbauction.svg'))
      .addSvgIcon('icon-check-inspection-partial',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/icon-check-inspection-partial.svg'))
      .addSvgIcon('icon-check-inspection-not-started',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/icon-check-inspection-not-started.svg'))
      .addSvgIcon('icon-check-inspection-complete',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/icon-check-inspection-complete.svg'))
      .addSvgIcon('live-ironplanet-icon',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Live-IP.svg'))
      .addSvgIcon('icon-pulse',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Icon-Pulse.svg'))
      .addSvgIcon('icon-tab-warning',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/Icon-Tab-Warning.svg'))
      .addSvgIcon('parent-component-lot',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/parent-component.svg'))
      .addSvgIcon('child-component-lot',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/child-component.svg'))
      .addSvgIcon('sort-indicator-none',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/sort-indicator-none.svg'))
      .addSvgIcon('sort-indicator-asc-grey',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/sort-indicator-asc-grey.svg'))
      .addSvgIcon('sort-indicator-desc-grey',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/sort-indicator-desc-grey.svg'))
      .addSvgIcon('sort-indicator-asc-white',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/sort-indicator-asc-white.svg'))
      .addSvgIcon('sort-indicator-desc-white',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/sort-indicator-desc-white.svg'))
      .addSvgIcon('not-verified',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/not-verified.svg'))
      .addSvgIcon('in-transit',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/in-transit.svg'))
      .addSvgIcon('transferred',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/transferred.svg'))
      .addSvgIcon('icon-yom-not-checked',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/icon-yom-not-checked.svg'))
      .addSvgIcon('pending-inspection',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/pending-inspection.svg'))
      .addSvgIcon('selling-remote',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/selling-remote.svg'))
      .addSvgIcon('do-not-advertise',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/do-not-avertise.svg'))
      .addSvgIcon('at-risk',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/at-risk.svg'))
      .addSvgIcon('ip-status',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/ip-status.svg'))
      .addSvgIcon('ready-to-transfer',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/ready-to-transfer.svg'))
      .addSvgIcon('unsigned',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/unsigned.svg'))
      .addSvgIcon('verified-green',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/verified-green.svg'))
      .addSvgIcon('title-status-new',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/title-status-new.svg'))
      .addSvgIcon('title-status-processing',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/title-status-processing.svg'))
      .addSvgIcon('title-status-verified',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/title-status-verified.svg'))
      .addSvgIcon('title-status-ready-for-sale',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/title-status-ready-for-sale.svg'))
      .addSvgIcon('title-status-in-transit',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/title-status-in-transit.svg'))
      .addSvgIcon('title-status-not-transferable',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/title-status-not-transferable.svg'))
      .addSvgIcon('title-status-transferable',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/title-status-transferable.svg'))
      .addSvgIcon('title-status-transferred',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/title-status-transferred.svg'))
      .addSvgIcon('icon-coordinator-not-review-asset',
      this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/coordinator-not-reviewed-asset.svg'))
      .addSvgIcon('icon-coordinator-review-asset',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/coordinator-reviewed-asset.svg'))
      .addSvgIcon('icon-vso',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/vso.svg'))
      .addSvgIcon('previous-event',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/previous-event.svg'))
      .addSvgIcon('icon-sequenced',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/sequenced.svg'))
      .addSvgIcon('eye-slash-solid',
        this.sanitizer.bypassSecurityTrustResourceUrl(cdnBaseHref + 'resources/icons/eye-slash-solid.svg'))
    ;
  }
}
